module.exports = __webpack_public_path__ + "static/media/Correct Box.7f789506.svg";